import createContext from '../../support/helpers/createContext';

import { Market } from '../../types/shared/Market';
import { PaymentsAndSalesByMarket } from '../../types/shared/MarketSales';

type PlacementCellBlur = {
  vendorID: string;
  paymentID?: string;
  noteCategoryID?: string;
  value: string | number;
};

type MarketSales = {
  activeMarket: Market | null | undefined;
  activeDate: string | null | undefined;
  allSales: PaymentsAndSalesByMarket | null | undefined;
  onPlacementCellBlur: (data: PlacementCellBlur) => void;
};

let [useMarketSalesContext, MarketSalesProvider] = createContext<MarketSales>();

export { useMarketSalesContext, MarketSalesProvider };
